import React, { createContext, useState } from "react";
import { ZoomMediaStream } from "./zoom/index-types";

interface MediaContext {
  audio: {
    encode: boolean;
    decode: boolean;
  };
  video: {
    encode: boolean;
    decode: boolean;
  };
  share: {
    encode: boolean;
    decode: boolean;
  };
  mediaStream: ZoomMediaStream | null;
  setMediaStream: React.Dispatch<React.SetStateAction<ZoomMediaStream | null>>;
  activeSpeaker: string | undefined;
  activeCamera: string | undefined;
  activeMicrophone: string | undefined;
  setActiveSpeaker: React.Dispatch<React.SetStateAction<string | undefined>>;
  setActiveCamera: React.Dispatch<React.SetStateAction<string | undefined>>;
  setActiveMicrophone: React.Dispatch<React.SetStateAction<string | undefined>>;
  isStartedVideo: boolean;
  setIsStartedVideo: React.Dispatch<React.SetStateAction<boolean>>;
  isStartedAudio: boolean;
  setIsStartedAudio: React.Dispatch<React.SetStateAction<boolean>>;
  /** Mute state of the session microphone, seeded from the preview screen. */
  isAudioMuted: boolean;
  setIsAudioMuted: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ZoomMediaContext = createContext<MediaContext | null>(null);

export const ZoomMediaProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [mediaStream, setMediaStream] = useState<ZoomMediaStream | null>(null);
  const [activeSpeaker, setActiveSpeaker] = useState<string | undefined>(
    undefined
  );
  const [activeCamera, setActiveCamera] = useState<string | undefined>(
    undefined
  );
  const [activeMicrophone, setActiveMicrophone] = useState<string | undefined>(
    undefined
  );
  const [isStartedVideo, setIsStartedVideo] = useState<boolean>(false);
  const [isStartedAudio, setIsStartedAudio] = useState<boolean>(false);
  const [isAudioMuted, setIsAudioMuted] = useState<boolean>(true);

  const initialContext: MediaContext = {
    audio: {
      encode: false,
      decode: false,
    },
    video: {
      encode: false,
      decode: false,
    },
    share: {
      encode: false,
      decode: false,
    },
    mediaStream,
    setMediaStream,
    activeSpeaker,
    setActiveSpeaker,
    activeCamera,
    setActiveCamera,
    activeMicrophone,
    setActiveMicrophone,
    isStartedVideo,
    setIsStartedVideo,
    isStartedAudio,
    setIsStartedAudio,
    isAudioMuted,
    setIsAudioMuted,
  };

  return (
    <ZoomMediaContext.Provider value={initialContext}>
      {children}
    </ZoomMediaContext.Provider>
  );
};
